import { APIEntityType, ArdoqId } from '@ardoq/api-types';
import { getModelTypeDictionaryKey } from '../enhanceScopeData';
import { getEntityById } from '../utils/getEntityById';
import { getEntityModelAndTypeID } from '../utils/getEntityModelAndTypeID';
import type { EnhancedScopeData } from '@ardoq/data-model';

export const getNumberFormatOptions = (
  entityId: ArdoqId,
  entityType: APIEntityType,
  enhancedScopeData: EnhancedScopeData,
  fieldName: string
) => {
  if (entityType === APIEntityType.FIELD) {
    const field = getEntityById(entityType, entityId, enhancedScopeData);
    return field?.numberFormatOptions;
  } else if (
    !(
      entityType === APIEntityType.COMPONENT ||
      entityType === APIEntityType.REFERENCE
    )
  ) {
    return null;
  }
  const { model, typeId } = getEntityModelAndTypeID(
    entityType as APIEntityType.COMPONENT | APIEntityType.REFERENCE,
    entityId,
    enhancedScopeData
  );
  if (!model || !typeId) return null;
  const fields =
    enhancedScopeData.fieldsByModelIdAndTypeId[
      getModelTypeDictionaryKey(model, typeId)
    ];
  return fields[fieldName]?.numberFormatOptions;
};
